exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss"), undefined);

// module
exports.push([module.id, ".ImproveLine__improveSurround___36fz8 {\n\tbackground-color: #eee;\n}\n\n.ImproveLine__single____Mz7v {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin: 0 0.3rem;\n\tpadding: 0.5rem;\n}\n\n.ImproveLine__icon___1v6YH {\n\tdisplay: flex;\n\tmargin-right: 0.3rem;\n}\n\n.ImproveLine__icon___1v6YH svg {\n\tcolor: " + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["primaryColour"] + ";\n}\n\n.ImproveLine__text___2Gsbp {\n\tmargin-right: 0.3rem;\n}\n\n.ImproveLine__content___2Bg9U {\n\tflex: 1;\n}\n", ""]);

// exports
exports.locals = {
	"primaryColour": "" + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["primaryColour"] + "",
	"pagePadding": "" + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["pagePadding"] + "",
	"improveSurround": "ImproveLine__improveSurround___36fz8",
	"single": "ImproveLine__single____Mz7v",
	"icon": "ImproveLine__icon___1v6YH",
	"text": "ImproveLine__text___2Gsbp",
	"content": "ImproveLine__content___2Bg9U"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/ImproveLine.icss
// module id = 1583
// module chunks = 0